export default {
  namespaced: true,
  state: {
    messages: '',
    isLoading: false,
  },
  getters: {
    isLoading: (state) => state.isLoading,
    messages: (state) => state.messages,
  },
  mutations: {
    ENABLE_LOADING(state) {
      state.isLoading = true;
    },
    DISABLE_LOADING(state) {
      state.isLoading = false;
    },
    SET_MESSAGES(state, messages) {
      state.messages = messages;
    },
    CLEAR_MESSAGES(state) {
      state.messages = '';
    },
  }
}
